import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter);

const routerList = [
    {
        path: '/',
        component: () => import( '../../pages/mainIndex.vue'),
        name:'passport',
        meta: {title: 'MiraStudent'},
    },
	{
	    path: '/login',
	    component: () => import( '../../pages/login/login.vue'),
	    name:'login',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/register',
	    component: () => import( '../../pages/login/register.vue'),
	    name:'register',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/registrationInformation',
	    component: () => import( '../../pages/login/registrationInformation.vue'),
	    name:'registrationInformation',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/classIndex',
	    component: () => import( '../../pages/forClass/index.vue'),
	    name:'classIndex',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/teacher',
	    component: () => import( '../../pages/forClass/teacher.vue'),
	    name:'teacher',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/cashDesk',
	    component: () => import( '../../pages/forClass/cashDesk.vue'),
	    name:'cashDesk',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/personalizationTeacher',
	    component: () => import( '../../pages/forClass/personalizationTeacher.vue'),
	    name:'personalizationTeacher',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/forStudy',
	    component: () => import( '../../pages/forClass/forStudy.vue'),
	    name:'forStudy',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/students',
	    component: () => import( '../../pages/students/index.vue'),
	    name:'students',
	    meta: {title: 'MiraStudent'},
		children:[
			{
			    path: '/studentsProgressReport',
			    component: () => import( '../../pages/students/progressReport.vue'),
			    name:'progressReport',
			    meta: {title: 'MiraStudent'},
			}
		]
	},
	{
	    path: '/message',
	    component: () => import( '../../pages/students/message.vue'),
	    name:'message',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/appointment',
	    component: () => import( '../../pages/students/appointment.vue'),
	    name:'appointment',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/teacherConfirms',
	    component: () => import( '../../pages/students/teacherConfirms.vue'),
	    name:'teacherConfirms',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/beforeBecomeTeacher',
	    component: () => import( '../../pages/teacher/beforeBecomeTeacher.vue'),
	    name:'beforeBecomeTeacher',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/becomeTeacher',
	    component: () => import( '../../pages/teacher/becomeTeacher.vue'),
	    name:'becomeTeacher',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/teacherIndex',
	    component: () => import( '../../pages/teacher/index.vue'),
	    name:'teacherIndex',
	    meta: {title: 'MiraStudent'},
		children:[
			{
			    path: '/classroomReport',
			    component: () => import( '../../pages/teacher/classroomReport.vue'),
			    name:'classroomReport',
			    meta: {title: 'MiraStudent'},
			},
			{
			    path: '/progressReport',
			    component: () => import( '../../pages/teacher/progressReport.vue'),
			    name:'progressReport',
			    meta: {title: 'MiraStudent'},
			}
		]
	},
	{
	    path: '/statusConfirms',
	    component: () => import( '../../pages/teacher/statusConfirms.vue'),
	    name:'teacher',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/teacherAppointment',
	    component: () => import( '../../pages/teacher/appointment.vue'),
	    name:'teacher',
	    meta: {title: 'MiraStudent'},
	},
	
	{
	    path: '/textTerms',
	    component: () => import( '../../pages/textContent/terms.vue'),
	    name:'textTerms',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/aboutUs',
	    component: () => import( '../../pages/textContent/aboutUs.vue'),
	    name:'aboutUs',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/contactUs',
	    component: () => import( '../../pages/textContent/contactUs.vue'),
	    name:'contactUs',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/problem',
	    component: () => import( '../../pages/textContent/problem.vue'),
	    name:'problem',
	    meta: {title: 'MiraStudent'},
	},
	{
	    path: '/404',
	    component: () => import( '../../pages/404.vue'),
	    name:'nodata404',
	    meta: {title: '抱歉你找的页面失踪了'},
	},
	{
	    path: '/refresh',
	    component: () => import( '../../pages/Refresh.vue'),
	    name:'refresh',
	    meta: {title: '刷新页面'},
	}
];
const routerObj = new VueRouter({
    routes:routerList
});

//console.log(routerList);

routerObj.beforeEach((to, from, next) => { 
     if(to.name == null){
        next({
            path:'/404'
        });
     }else{
       // document.title =  to.meta.title + ' - 应用管理后台'
	    document.title = 'Mira Talker Limited'
	   
       next();
     }
})

export default routerObj;